import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "50.336 1172 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M60.336 1192a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138a9.7 9.7 0 0 1 3.9-.787q2.075 0 3.9.787a10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.138 3.175a9.7 9.7 0 0 1 .787 3.9 9.7 9.7 0 0 1-.787 3.9 10.1 10.1 0 0 1-2.138 3.175q-1.35 1.35-3.175 2.138a9.7 9.7 0 0 1-3.9.787m0-2q3.35 0 5.675-2.325t2.325-5.675q0-.175-.012-.363a5 5 0 0 1-.013-.312 1.98 1.98 0 0 1-.675 1.2q-.55.475-1.3.475h-2q-.824 0-1.412-.588a1.93 1.93 0 0 1-.588-1.412v-1h-4v-2q0-.824.588-1.412a1.93 1.93 0 0 1 1.412-.588h1q0-.574.312-1.012.313-.438.763-.713-.499-.125-1.013-.2a7 7 0 0 0-1.062-.075q-3.35 0-5.675 2.325T52.336 1182h5q1.65 0 2.825 1.175t1.175 2.825v1h-3v2.75q.5.125.987.188.488.062 1.013.062",
      class: "fills",
      style: {"fill":"#456332","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }